module.exports = __webpack_public_path__ + "images/69d8c55f89ba5bfdccd20f1a57f244d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/thesuperlatives-miniposter.jpg
// module id = ./webpack/assets/img/thesuperlatives-miniposter.jpg
// module chunks = 0